import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cuid from "cuid";

import { HeartSmallSvg } from "@assets/js/icons";
import PDPProductImages from "../PDPProductImages";
import { renderedImagePath } from "../../ProductImage";

import {
  PORTFOLIO_TYPE,
  OVERLAY,
  SITE_MODE,
  CONFIGURATOR_MODE,
} from "@constants";

import {
  useActiveConfigurationSKU,
  useConfiguratorMode,
  useActiveProductData,
  useActiveUniqueMaterial
} from "@store/pdp";

import { useSubmissionMode, useSubmissionContent } from "@store/portfolio";
import useHeaderStore from "@store/header";
import { useCurrentSiteMode } from "@store/global";
import { log } from "@assets/js/utils";

import "./pdp-product-viewer.scss";

const PDPProductViewer = () => {
  const [configuratorMode] = useConfiguratorMode();
  const [currentSiteMode] = useCurrentSiteMode();
  const [activeConfigurationSKU] = useActiveConfigurationSKU();
  const [activeProductData] = useActiveProductData();
  const [activeUniqueMaterial] = useActiveUniqueMaterial();
  const [, setSubmissionMode] = useSubmissionMode();
  const [, setSubmissionContent] = useSubmissionContent();
  const setMenuOverlayActive = useHeaderStore((store) => store.setMenuOverlayActive);

  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const wishListClickHandler = () => {
    let content = {
      id: cuid(),
      imageSrcHigh:
        configuratorMode === CONFIGURATOR_MODE.NONE
          ? activeProductData.imageUrl
          : renderedImagePath({
              imageId: activeConfigurationSKU,
              sw: 300,
            }),
      imageSrcLow:
        configuratorMode === CONFIGURATOR_MODE.NONE
          ? activeProductData.imageUrl
          : renderedImagePath({
              imageId: activeConfigurationSKU,
              sw: 50,
            }),
      imageWidth: 300,
      imageHeight: 300,

      portfolioItem: {
        productId: activeConfigurationSKU,
        modelTypeId: activeProductData.model.typeId,
        quantity: 1,
        isUniqueMaterial: !!activeUniqueMaterial
      },
    };

    setSubmissionContent(content);
    setSubmissionMode(PORTFOLIO_TYPE.PRODUCT);
    setMenuOverlayActive(OVERLAY.PORTFOLIO_SUBMISSION);
  };

  //animation presets
  useEffect(() => {}, [activeConfigurationSKU, activeUniqueMaterial]);

  return (
    <div className="pdp-product-viewer" data-active-sku={activeConfigurationSKU}>
      <div className="pdp-product-viewer__inner">
        <PDPProductImages 
          onSliderChange={(index) => setActiveImageIndex(index)} 
          skuImageUrl={!!activeUniqueMaterial ? activeUniqueMaterial?.imageUrl : activeProductData?.imageUrl ? activeProductData.imageUrl : ""} />
      </div>

      {currentSiteMode === SITE_MODE.RESIDENTIAL && activeImageIndex == 0 && (
        <button className="basic-link right" onClick={wishListClickHandler}>
          <span className="icon">
            <HeartSmallSvg fillHex="transparent" strokeHex="#000" />
          </span>
        </button>
      )}
    </div>
  );
};
PDPProductViewer.propTypes = {};

export default PDPProductViewer;
